export default "__VITE_ASSET__BUHwVgNU__"